import { useEffect, useState } from 'react'
import PhoneEntry from './PhoneEntry'
import EmailEntry from './EmailEntry'
import {
  detectAuthChannel,
  getStoredChannel,
  setStoredChannel,
  type AuthChannel,
} from '@/utils/geoChannel'
import styles from './Login.module.css'

export default function Login() {
  const [channel, setChannel] = useState<AuthChannel | null>(() => getStoredChannel())
  const [askChoice, setAskChoice] = useState(false)

  useEffect(() => {
    if (channel) return
    let cancelled = false
    detectAuthChannel().then((detected) => {
      if (cancelled) return
      if (detected) {
        setChannel(detected)
      } else {
        setAskChoice(true)
      }
    })
    return () => {
      cancelled = true
    }
  }, [channel])

  const pick = (next: AuthChannel) => {
    setStoredChannel(next)
    setChannel(next)
    setAskChoice(false)
  }

  const toggle = () => {
    pick(channel === 'phone' ? 'email' : 'phone')
  }

  if (askChoice && !channel) {
    return (
      <div className={styles.chooser}>
        <h1 className={styles.chooserTitle}>Where are you?</h1>
        <p className={styles.chooserSubtitle}>
          We'll send your verification code by WhatsApp in India or by email elsewhere.
        </p>
        <button className={styles.chooserButton} onClick={() => pick('phone')}>
          I'm in India
        </button>
        <button className={styles.chooserButton} onClick={() => pick('email')}>
          I'm somewhere else
        </button>
      </div>
    )
  }

  if (!channel) {
    return <div className={styles.loading} aria-busy>Loading…</div>
  }

  return channel === 'phone' ? (
    <PhoneEntry onSwitchChannel={toggle} />
  ) : (
    <EmailEntry onSwitchChannel={toggle} />
  )
}
